import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {

  // 导入
  importRankExcel({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseDataManagement/importRankExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 导出
  exportRankData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseDataManagement/exportRankData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 风险导入
  importRiskExcel({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseDataManagement/importRiskExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 风险导出
  exportRiskData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseDataManagement/exportRiskData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 主列表
  selectMainListData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseDataManagement/selectMainListData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 导出相对分调整
  exportRelativeAdjust({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseDataManagement/exportRelativeAdjust`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 相对分调整导入
  importRelativeAdjustExcel({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseDataManagement/importRelativeAdjustExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 导出AI批次
  exportAiSmartBatch({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseDataManagement/exportAiSmartBatch`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // AI批次导入
  importAiSmartBatch({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/baseDataManagement/importAiSmartBatch`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
